
import { myListsViewStyles } from "@insite/content-library/Widgets/MyLists/MyListsView";
import { css } from "styled-components";

myListsViewStyles.wrapper = {
    css: css`
        margin-top: 10px;
    `,
};
